import React from 'react';
import { Data } from 'service/util';

import LocationSelect from 'component/dropdown/LocationSelect';
import ServiceWeekdayPicker from 'component/service/ServiceWeekdayPicker';

class ClientFilterBar extends React.Component
{
  constructor(props)
  {
    super(props);
    this.setLocation = this.setLocation.bind(this);
    this.setWeekday  = this.setWeekday.bind(this);
  }

  forceUpdate()
  {
    super.forceUpdate();
    if (this.props.onApply)
    {
      if (this.__tid) window.clearTimeout(this.__tid);
      this.__tid = window.setTimeout(() => {
        this.__tid = null;
        this.props.onApply();
      }, 300);
    }
  }

  setFilter(key, value)
  {
    if ('number' === typeof value && isNaN(value)) value = null;
    this.props.filter[key] = value;
    this.forceUpdate();
  }
  setLocation(srv_dis, srv_loc)
  {
    Object.assign(this.props.filter, { srv_dis, srv_loc });
    this.forceUpdate();
  }
  setWeekday(d1,d2,d3,dict)
  {
    this.props.filter.weekdays = dict;
    this.forceUpdate();
  }

  render()
  {
    return (<>
      <div className="row">
        <label className="field company">
          <strong>公司</strong>
          <div>
            <select id="f-company" value={this.props.filter.company}
              onChange={ e=>this.setFilter('company', e.target.value) }>
              <option value="">全部</option>
              { Data.company.map(com =>
                <option key={com.cd} value={com.cd}>{com.cd} - {com.name}</option>
              )}
            </select>
          </div>
        </label>
        <label className="field location">
          <strong>地點</strong>
          <div>
            <LocationSelect all={true} noLabel={true}
              district={this.props.filter.srv_dis}
              location={this.props.filter.srv_loc}
              onUpdate={this.setLocation}
            />
          </div>
        </label>
      </div>
      <div className="split-4">
        <div>
          <label className="field license">
            <strong>車牌</strong>
            <input id="f-license" value={this.props.filter.license} autoComplete="false"
                  onChange={ e=>this.setFilter('license', e.target.value.toUpperCase().trimStart()) } />
          </label>
          <label className="field owner">
            <strong>車主</strong>
            <input value={this.props.filter.client} autoComplete="false"
                  onChange={ e=>this.setFilter('client', e.target.value.trimStart()) } />
          </label>
          <label className="field worker">
            <strong>工人</strong>
            <input value={this.props.filter.worker} autoComplete="false"
                  onChange={ e=>this.setFilter('worker', e.target.value.trimStart()) } />
          </label>
          <label className="field mod-by">
            <strong>修訂人</strong>
            <input value={this.props.filter.mod_by} autoComplete="false"
                  onChange={ e=>this.setFilter('mod_by', e.target.value.trimStart()) } />
          </label>
          <label className="field mod-by">
            <strong>聯絡</strong>
            <input value={this.props.filter.contact} placeholder="電話/電郵" autoComplete="false"
                  onChange={ e=>this.setFilter('contact', e.target.value.trimStart()) } />
          </label>
        </div>
        <div>
          <label className="field location">
            <strong>樓層</strong>
            <input value={ this.props.filter.srv_floor||''}
                  onChange={ e=>this.setFilter('srv_floor', e.target.value.trimStart()) } />
          </label>
          <label className="field psn">
            <strong>車位</strong>
            <input value={ this.props.filter.srv_psn||''}
                  onChange={ e=>this.setFilter('srv_psn', e.target.value.trimStart()) } />
          </label>
          <label className="field outlook">
            <strong>車款</strong>
            <input value={this.props.filter.outlook} autoComplete="false"
                  onChange={ e=>this.setFilter('outlook', e.target.value.trimStart()) } />
          </label>
          <label className="field rot">
            <strong>附加項目</strong>
            <input value={this.props.filter.rot} autoComplete="false"
                  onChange={ e=>this.setFilter('rot', e.target.value.trimStart()) } />
          </label>
        </div>
        <div>
          <label className="field vhtype">
            <strong>車種</strong>
            <div>
              <select id="f-service" value={this.props.filter.vhType}
                      onChange={ e => this.setFilter('vhType', e.target.value) }>
                <option value="">全部</option>
                { Data.vtype.map(t =>
                  <option key={`vt-${t.id}`} value={t.id}>{t.id} - {t.desc}</option>
                )}
              </select>
            </div>
          </label>
          <label className="field plan">
            <strong>服務</strong>
            <div>
              <select value={this.props.filter.service}
                      onChange={ e=>this.setFilter('service', e.target.value) }>
                <option value="">全部</option>
                { Data.plan.map(p =>
                  <option key={`plan-${p}`} value={p}>{p}</option>
                )}
              </select>
            </div>
          </label>
          <label className="field vhtype">
            <strong>服務日</strong>
            <div>
              <ServiceWeekdayPicker plan="filter"
                  onChange={this.setWeekday} />
            </div>
          </label>
          <label className="field s-fee">
            <strong>月費</strong>
            <div className="flex g2">
              <input value={this.props.filter.fee_min||''} placeholder="最少" type="number"
                    onChange={ e=> this.setFilter('fee_min', parseInt(e.target.value, 10)) } />
              <span> 至 </span>
              <input value={this.props.filter.fee_max||''} placeholder="最大" type="number"
                    onChange={ e=> this.setFilter('fee_max', parseInt(e.target.value, 10)) } />
            </div>
          </label>
          <label className="field s-exfee">
            <strong>附加費</strong>
            <div className="flex g2">
              <input value={this.props.filter.exfee_min||''} placeholder="最少" type="number"
                    onChange={ e=> this.setFilter('exfee_min', parseInt(e.target.value, 10)) } />
              <span> 至 </span>
              <input value={this.props.filter.exfee_max||''} placeholder="最大" type="number"
                    onChange={ e=> this.setFilter('exfee_max', parseInt(e.target.value, 10)) } />
            </div>
          </label>
          <label className="field s-active">
            <strong>現有客戶</strong>
            <input id="f-active" type="checkbox" checked={this.props.filter.active}
                  onChange={e=> this.setFilter( 'active', e.target.checked )} />
          </label>
        </div>
        <div>
        <label className="field mobill">
            <strong>月結</strong>
            <div>
              <select value={this.props.filter.is_mobill} onChange={ e=>this.setFilter('is_mobill', e.target.value) }>
                <option value="">全部</option>
                <option value="1">是</option>
                <option value="0">否</option>
              </select>
            </div>
          </label>
          <label className="field rtn-evl">
            <strong>回郵</strong>
            <div>
              <select value={this.props.filter.is_rtn_envelope} onChange={ e=>this.setFilter('is_rtn_envelope', e.target.value) }>
                <option value="">全部</option>
                <option value="1">要</option>
                <option value="0">不要</option>
              </select>
            </div>
          </label>
          <label className="field print-bill">
            <strong>印收費單</strong>
            <div>
              <select value={this.props.filter.is_print_bill} onChange={ e=>this.setFilter('is_print_bill', e.target.value) }>
                <option value="">全部</option>
                <option value="1">要</option>
                <option value="0">不要</option>
              </select>
            </div>
          </label>
          <label className="field remarks">
            <strong>備註</strong>
            <input value={this.props.filter.remarks} autoComplete="false"
                  onChange={ e=>this.setFilter('remarks', e.target.value.trimStart()) } />
          </label>
        </div>
      </div>
    </>);
  }
}

export default ClientFilterBar;
